import React from "react";
import add_icon_step3 from "../../../../images/icons/add_icon-step3.svg";

const SkillAnimation = ({ myAnimationHidden, myAnimationFlagMove, currentSkillAddTraektory, coords }) => {
  return (
    <div
      className={myAnimationHidden
        ? " my_animation my_animation-hidden"
        : " my_animation "
      }
      style={{
        position: "absolute",
        top: `${coords.clientY}px`,
        left: `${coords.clientX - coords.widthElem}px`,
        color: "white",
        padding: "2px 5px 2px 10px",
        backgroundColor: "rgba(255, 52, 52, 0.7)",
        borderRadius: 34,
        display: myAnimationFlagMove ? "block" : "none"
      }}
    >
      {currentSkillAddTraektory && currentSkillAddTraektory}
      <img style={{ marginLeft: 5 }} src={add_icon_step3} />
    </div>
  );
};

export default SkillAnimation;